export default {
    supplies:[],
    supply:{},
}
